import React, { useState } from 'react'
import { getTenantInfoByKey, parseMillisecondsToHoursAndMinutes } from '../../../../helpers/helpers'
import { t } from 'i18next'
import PermanenceSubTotalsDetailTable from '../PermanenceSubTotalsDetailTable/PermanenceSubTotalsDetailTable';

const PermanenceTotalsDetailTableList = ({ totalsReport }) => {

    const [showMore, setShowMore] = useState(false);

    const haveBuildings = getTenantInfoByKey('is_building');
    const haveAccessOpenings = getTenantInfoByKey('is_access_opening');

    const haveBuildingsAndNoOpenings = haveAccessOpenings === false && haveBuildings === true;

    const codeKey = haveBuildingsAndNoOpenings ? 'building_code' : 'opening_code';
    const descriptionKey = haveBuildingsAndNoOpenings ? 'building_description' : 'opening_description';

    return (
        <>
            <tr className='text-center'>
                {(haveAccessOpenings === true || haveBuildings === true) && (
                    <>
                        <td className='custom-border blue-text'>
                            {totalsReport[codeKey] ? totalsReport[codeKey] : '-'}
                        </td>
                        <td className='custom-border blue-text'>
                            {totalsReport[descriptionKey] ? totalsReport[descriptionKey] : t('NO_ASSIGNMENT')}
                        </td>
                    </>
                )}
                <td
                    className='custom-border dark-text'
                    style={{ fontSize: '14px' }}
                >
                    {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_normal).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_normal).split(':')[1])}min
                </td>
                <td
                    className='custom-border dark-text'
                    style={{ fontSize: '14px' }}
                >
                    {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_50).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_50).split(':')[1])}min
                </td>
                <td
                    className='custom-border dark-text'
                    style={{ fontSize: '14px' }}
                >
                    {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_100).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_100).split(':')[1])}min
                </td>
                <td className='blue-text'>
                    {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_total).split(':')[0])}hs {Number(parseMillisecondsToHoursAndMinutes(totalsReport.hs_total).split(':')[1])}min
                </td>
                <td className='text-center'>
                    {(haveAccessOpenings && haveBuildings) && (
                        <i
                            type='button'
                            className={`fa-solid fa-chevron-${showMore ? 'up' : 'down'}`}
                            onClick={() => setShowMore(!showMore)}
                        >
                        </i>
                    )}
                </td>
            </tr>
            {showMore && (
                <tr>
                    <td
                        colSpan={8}
                        style={{ background: '#F8FCFF' }}
                    >
                        <PermanenceSubTotalsDetailTable subTotalsReport={totalsReport.buildings} />
                    </td>
                </tr>
            )}
        </>
    )
}

export default PermanenceTotalsDetailTableList